<template>
  <div :class="!mobile ? 'seat-list-wrapper' : 'seat-list-wrapper-mobile'">
    <v-text-field
      id="election-search-input"
      :style="!mobile ? 'padding: 20px 0 0 0;' : ''"
      class="container"
      :value="search"
      @input="searchFiltering"
      label="Enter State, CD, or Candidate"
      @blur="isFocused = false"
      @focus="isFocused = true"
      :autofocus="mobile"
      single-line
    ></v-text-field>
    <div class="container election-list-wrapper" v-if="filteredElections.length > 0 && search" :style="!mobile ? 'padding-top: 0px;' : ''">
      <div class="election-list-item-wrapper"
        v-for="(item, index) in filteredElections"
        :key="index"
        @click="itemClick(item)">
        <span class="election-list-item-text" v-if="item.cd">{{ item.state }} {{ item.cd }} House Seat</span>
        <span class="election-list-item-text" v-else>{{ item.state }} Senate Seat
          <template v-if="item.specialElection"> (Special)</template>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import debounce from 'lodash.debounce'
import omit from 'lodash.omit'

const computed = {
  ...mapGetters({
    elections: 'elections/list',
    showSearch: 'ux/search',
    mobile: 'ux/mobile'
  }),
  filteredElections () {
    let elections = this.elections

    elections = elections.filter((item) => {
      if (item.cd) {
        return item.specialElection !== true
      } else {
        return item
      }
    })

    if (this.search) {
      elections = elections.filter((e) => {
        const search = this.search.trim().toLowerCase().split(/[ -]+/).filter((e) => e.trim().length > 0)
        e.candidates = ''
        const parsed = JSON.parse(e.electionJson)
        Object.values(parsed.current_election).forEach((candidate, index) => {
          e.candidates += candidate.candidate_name
          if ((index + 1) !== Object.values(parsed.current_election).length) {
            e.candidates += ', '
          }
        })
        const newObj = omit(e, 'electionJson', 'dateModified', 'geoid', 'id', 'openSeat', 'uncontested', 'turnoutCount', 'senateClass', 'primaryDate')
        const item = JSON.stringify(Object.values(newObj)).toLowerCase()
        return search.every(s => item.includes(s) === true)
      })
      return elections.sort((a, b) => {
        let aCd = null
        let bCd = null
        a.cd ? aCd = a.cd : aCd = 0
        b.cd ? bCd = b.cd : bCd = 0
        const nameA = a.state + aCd
        const nameB = b.state + bCd
        return nameA.localeCompare(nameB)
      })
    } else {
      return elections
    }
  }
}

const methods = {
  ...mapActions({
    toggleClosed: 'ux/toggleClosed'
  }),
  itemClick (item) {
    let chamber = null
    if (item.cd) {
      chamber = 'house'
    } else {
      chamber = 'senate'
    }
    this.$router.push({ name: chamber, params: { raceId: item.raceId } })
  },
  searchFiltering: debounce(function (search) {
    this.search = search
  }, 300)
}

export default {
  computed,
  methods,
  data () {
    return {
      search: null,
      isFocused: false
    }
  },
  watch: {
    showSearch () {
      this.search = null
    },
    $route (to, from) {
      this.search = null
      if (document.getElementsByTagName('body')[0].style.overflow === 'hidden') {
        document.getElementsByTagName('body')[0].style.overflow = 'auto'
      }
      this.toggleClosed()
    }
  },
  beforeDestroy () {
    if (document.getElementsByTagName('body')[0].style.overflow === 'hidden') {
      document.getElementsByTagName('body')[0].style.overflow = 'auto'
    }
  }
}
</script>

<style>
.seat-list-wrapper {
  position: relative;
}

.seat-list-wrapper .election-list-wrapper {
  height: 120px;
}

.election-list-wrapper {
  padding-top: 0px;
  height: 100%;
  overflow: auto;
}

.seat-list-wrapper-mobile {
  padding: 60px 0 0 0;
  position: fixed;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100vh;
  z-index: 600;
  background-color: rgba(255, 255, 255, 0.95) !important;
}

.fixed-nav-search {
  z-index: 100;
  height: calc(100vh - 270px);
  padding-top: 20px;
  padding-bottom: 60px;
}

.mobile-menu-open {
  height: calc(100vh - 440px) !important;
}

.election-list-item-wrapper {
  padding: 5px 0;
  cursor: pointer;
}

.election-list-item-wrapper:hover {
  opacity: 0.7;
}

.election-list-item-text {
  display: flex;
  justify-content: flex-start;
  font-size: 0.9em;
  letter-spacing: 0.02em;
  font-weight: 400;
  color: #333;
}

v-list-tile:hover {
  background-color: red;
}

.seat-list-wrapper-mobile .input-group label {
  padding-left: 12px !important;
}

@media only screen and (max-width: 960px) {
  .election-list-item-text {
    font-size: 1.3em;
    letter-spacing: 0.08em;
    justify-content: center;
    text-transform: uppercase;
  }

  .seat-list-wrapper-mobile .input-group label {
    padding-left: 0;
  }

  .input-group--text-field label {
    top: none;
    left: 0px;
  }
}

@media only screen and (max-width: 500px) {
  .election-list-item-text {
    font-size: 1em;
    letter-spacing: 0.01em;
  }
}

@media only screen and (max-width: 420px) {
  .fixed-nav-search {
    height: calc(100vh - 270px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/SeatSearch.vue